import type { FilesFormatSchemaWithId } from '@iconik-io/iconik-api/src/services/files';

export const ARCHIVED = 'ARCHIVED';
export const ARCHIVING = 'ARCHIVING';
export const FAILED_TO_ARCHIVE = 'FAILED_TO_ARCHIVE';
export const NOT_ARCHIVED = 'NOT_ARCHIVED';
export const FAILED = 'FAILED';

export const archiveStatus = [
  { label: 'Archiving', value: ARCHIVING, bsStyle: 'info' },
  { label: 'Failed to Archive', value: FAILED_TO_ARCHIVE, bsStyle: 'danger' },
  { label: 'Archived', value: ARCHIVED, bsStyle: 'warning' },
  { label: 'Not Archived', value: NOT_ARCHIVED, bsStyle: 'warning' },
] as const;

export type ArchiveStatus = NonNullable<
  FilesFormatSchemaWithId['archive_status']
>;
